// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__auWiD"};